import { projectContext } from '@/layouts/MainLayout'
import { ID } from '@/services/common.model'
import { createDirectory } from '@/services/file/file'
import { ModalForm } from '@ant-design/pro-form'
import { Form } from 'antd'
import Input from 'antd/lib/input/Input'
import { memo, useContext } from 'react'

interface NewDirectoryProps {
  trigger: JSX.Element
  dirId?: ID
  onSuccess?: Function
}

export default memo<NewDirectoryProps>(function NewDirectory(props) {
  const [form] = Form.useForm()
  const { projectId, projectType } = useContext(projectContext)
  const { trigger, dirId, onSuccess } = props

  return (
    <ModalForm
      form={form}
      trigger={trigger}
      width={500}
      title='New Directory'
      modalProps={{
        maskClosable: false
      }}
      onVisibleChange={(visible: boolean) => {
        visible && form.setFieldsValue({ name: '' })
      }}
      onFinish={async (values) => {
        try {
          await createDirectory({ ...values, dirId }, { projectId, projectType })
          onSuccess?.()
          return true
        } catch (err) {
          return false
        }
      }}
    >
      <Form.Item label='Name' name='name'>
        <Input />
      </Form.Item>
    </ModalForm>
  )
})
